
import * as d3 from "../lib/d3.js";
import {localStash} from "../util/stash.js";
import {$} from "../util/seq.js";
import {isString} from "../lib/underscore.js";
import {flatten} from "../util/arrays.js";
import {createModel} from "./model.js";
import {mapElementsV2} from "../engine/map.js";


const knownMapElements = new Set(Object.keys(mapElementsV2));
const initialMapScene = {
    version: 2,
    elements: [
        "rivers",
        "lakes",
        "coastline",
    ],
    // elements: [...knownMapElements],
};
const initialShowCta = d3.select(".cta-bar").property("hidden") !== true;
const initialFontSize = localStash.get("settings.font_size") ?? "medium";

const schema = {
    // {version: number, elements: string[]}, where "version" is the value 2 and "elements" is the set of map elements
    // to show on the globe. See knownMapElements for the set of allowed values.
    map_scene:          [isMapScene, initialMapScene],

    // allowed values: "bilinear", "nearest"
    interpolation_type: ["string", "bilinear"],  // CONSIDER: Rename to sampling_method and should be settable per layer
                                                 // For example, FIRMS might support closest, closest N within R km, etc.
    // true when high resolution data and rendering will be used
    hd_enabled:         ["boolean", false],
    // most recent status message
    status:             ["string", undefined],
    // most recent error message
    error:              ["string", undefined],
    // how complete the current task is, on the scale [0, 1] (inclusive); undefined when no running task
    progress:           ["number", undefined],

    // allowed values: "device", "Etc/UTC"
    display_timezone:   ["string", "device"],
    // true if the menu is to be shown
    show_menu:          ["boolean", false],
    // a note to show to, and to be dismissed by, the user
    notice:             ["string", undefined],
    // true if the call-to-action is to be shown
    show_cta:           ["boolean", initialShowCta],
    // [0, 100] percentage (inclusive) from left edge of colorbar
    colorbar_cursor:    ["number", undefined],
    // maps layer names to unit symbols ({"wind": "m/s"}), storing the most recently selected units, if any
    selected_units:     [isSelectedUnits, undefined],
    // allowed values: "x-small", "small", "medium", "large", "x-large"
    font_size:          ["string", initialFontSize],
};

function isMapScene(val) {
    return val.version === 2 && Array.isArray(val.elements) && val.elements.every(e => knownMapElements.has(e));
}

function isSelectedUnits(val) {
    const entries = flatten(Object.entries(val));
    return entries.length >= 2 && entries.every(isString);
}

export const sessionStore = createModel(schema);

// Persist some session values to localStorage
sessionStore.on($`change:font_size`, val => localStash.put("settings.font_size", val ?? null));
